import React, { useEffect, useState } from "react";
import Joyride, { STATUS } from "react-joyride";

const PatientDetailTour = ({ isLoading, activeTab, depenentModal, hasChatButton, hasSwitchDependent, forceStart, onTourEnd }) => {
  const [steps, setSteps] = useState([]);
  const [run, setRun] = useState(false);

  useEffect(() => {
    if (isLoading) return;

    if (forceStart) setRun(false);

    const timer = setTimeout(() => {
      let allSteps = [];

      if (depenentModal && hasSwitchDependent) {
        const seenModal = localStorage.getItem("tour_seen_modal");
        
        if (forceStart || !seenModal) {
          allSteps.push({
            target: ".tour-detail-modal",
            content: "Switch here to view or manage dependents linked to this patient’s account.",
            placement: "center",
            disableBeacon: true,
            disableScrolling: true,
          });
        }
      } 
      else {
        const seenGeneralIntro = localStorage.getItem("tour_seen_intro");
        if ((forceStart || !seenGeneralIntro) && activeTab === 1) {
          allSteps.push(
            { target: ".tour-detail-status", content: "Start here to confirm the patient’s identity, status, location, and group.", placement: "bottom", disableBeacon: true },
            { target: ".tour-tabs-overall", content: "Use these tabs to move between patient details, employer info, insurance, payments, documents, and chat history.", placement: "bottom", disableBeacon: true },
            { target: ".tour-detail-infotab", content: "Review key personal details like contact info, relationship, and assigned tags.", placement: "bottom", disableBeacon: true }
          );
        }

        if ((forceStart || !localStorage.getItem("tour_seen_detail_chat")) && activeTab === 1 && hasChatButton) {
          allSteps.push({ target: ".tour-detail-chat-button", content: "Start a conversation with the patient here.", placement: "bottom", disableBeacon: true });
        }

        if ((forceStart || !localStorage.getItem("tour_seen_detail_switch")) && activeTab === 1 && hasSwitchDependent) {
          allSteps.push({ target: ".tour-detail-switch", content: "Select a dependent from this list to view their details or switch context.", placement: "bottom", disableBeacon: true });
        }

        if (activeTab === 2) {
          if (forceStart || !localStorage.getItem("tour_seen_employer")) {
             allSteps.push({ target: ".tour-detail-employer", content: "Review the patient's current employer, subscriber ID, group status, and dependent relationships here.", placement: "bottom", disableBeacon: true });
          }
        }

        if (activeTab === 3) {
          if (forceStart || !localStorage.getItem("tour_seen_insurance")) {
             allSteps.push({ target: ".tour-detail-insurance", content: "Check the patient's primary insurance coverage, plan details, and member IDs.", placement: "bottom", disableBeacon: true });
          }
        }

        if (activeTab === 4) {
          if (forceStart || !localStorage.getItem("tour_seen_request")) {
             allSteps.push({ target: ".tour-detail-request", content: "Create and manage payment requests here.", placement: "top", disableBeacon: true, disableScrolling: true });
          }
        }
        
        if (activeTab === 5) {
          if (forceStart || !localStorage.getItem("tour_seen_document")) {
             allSteps.push({ target: ".tour-detail-document", content: "Create and track document requests related to this patient’s care.", placement: "top", disableBeacon: true, disableScrolling: true });
          }
        }
        if (activeTab === 6) {
           if (forceStart || !localStorage.getItem("tour_seen_previous")) {
              allSteps.push({ target: ".tour-detail-previous", content: "View past conversations between providers and this patient.", placement: "top", disableBeacon: true, disableScrolling: true });
           }
        }
      }

      setSteps(allSteps);
      if (allSteps.length > 0) setRun(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [isLoading, activeTab, depenentModal, hasChatButton, hasSwitchDependent, forceStart]); // <-- Added isLoading to dependencies

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      hideCloseButton={true}
      scrollToFirstStep={true}
      scrollOffset={250}
      callback={(data) => {
        if ([STATUS.FINISHED, STATUS.SKIPPED].includes(data.status)) {
          setRun(false);
          if (onTourEnd) onTourEnd();

          if (depenentModal && hasSwitchDependent) localStorage.setItem("tour_seen_modal", "true");
          
          if (!depenentModal) {
            if (activeTab === 1) {
              localStorage.setItem("tour_seen_intro", "true");
              if (hasChatButton) localStorage.setItem("tour_seen_detail_chat", "true");
              if (hasSwitchDependent) localStorage.setItem("tour_seen_detail_switch", "true");
            }
            if (activeTab === 2) localStorage.setItem("tour_seen_employer", "true");
            if (activeTab === 3) localStorage.setItem("tour_seen_insurance", "true");
            if (activeTab === 4) localStorage.setItem("tour_seen_request", "true");
            if (activeTab === 5) localStorage.setItem("tour_seen_document", "true");
            if (activeTab === 6) localStorage.setItem("tour_seen_previous", "true");
          }
        }
      }}
      styles={{
        options: { primaryColor: "#000000", textColor: "#000000", zIndex: 10000 },
        tooltip: { borderRadius: '8px', padding: '20px' },
        buttonNext: { backgroundColor: '#3c8138', borderRadius: '4px' },
        buttonBack: { color: '#3c8138' }
      }}
    />
  );
};

export default PatientDetailTour;